<div class="router-container">
<!--  <mat-progress-bar class="position-fixed" mode="indeterminate" *ngIf="loading"></mat-progress-bar>-->

  <router-outlet></router-outlet>
</div>
